export const PROS_PER_PAGE = 10;
export const DEFAULT_OFFSET = 0;



// WEBPACK FOOTER //
// ./src/modules/home/modules/browser/home/common/BusinessListConstants.js